import { Routes } from '@angular/router';
import { LoginComponent } from './shared/login/login.component';
import { PageNotfoundComponent } from './shared/page-notfound/page-notfound.component';
import { AuthGuard } from '@bcone/neo-app-sdk';
import { AppConstants } from './constants/app-constants';
var ɵ0 = { title: AppConstants.PAGE_TITLES.LOGIN }, ɵ1 = { title: AppConstants.PAGE_TITLES.USER_AND_FILE_AUDIT }, ɵ2 = { title: AppConstants.PAGE_TITLES.ERROR_AND_WARNING_AUDIT }, ɵ3 = { title: AppConstants.PAGE_TITLES.PAGE_NOT_FOUND };
var routes = [
    {
        path: 'login',
        component: LoginComponent,
        data: ɵ0
    },
    {
        path: 'user-and-file-audit',
        loadChildren: './user-and-file-audit/user-and-file-audit.module#UserAndFileAuditModule',
        canActivate: [AuthGuard],
        data: ɵ1
    },
    {
        path: 'error-and-warning-audit',
        loadChildren: './error-and-warning-audit/error-and-warning-audit.module#ErrorAndWarningAuditModule',
        canActivate: [AuthGuard],
        data: ɵ2
    },
    {
        path: 'page-not-found',
        component: PageNotfoundComponent,
        pathMatch: 'full',
        data: ɵ3
    },
    {
        path: '',
        redirectTo: '/user-and-file-audit',
        pathMatch: 'full'
    },
    {
        path: '**',
        component: PageNotfoundComponent,
        pathMatch: 'full'
    }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
